var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNearMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.603,
    height: 23.718,
    viewBox: "0 0 16.603 23.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-pin-drop",
    "data-name": "Icon material-pin-drop",
    d: "M22.917,10.115a7.115,7.115,0,0,0-14.231,0c0,5.337,7.115,13.045,7.115,13.045S22.917,15.452,22.917,10.115Zm-9.487,0A2.372,2.372,0,1,1,15.8,12.487,2.379,2.379,0,0,1,13.43,10.115ZM7.5,24.346v2.372H24.1V24.346Z",
    transform: "translate(-7.5 -3)",
    fill: "#bf772f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearMe);
export default __webpack_public_path__ + "static/media/near-me.c89cd0b3e1641645329f3b4d79c07f05.svg";
export { ForwardRef as ReactComponent };